import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { EstimateTypeClient, EstimateTypeView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class EstimateTypeService {
    constructor(private readonly client: EstimateTypeClient) {}

    async getAll(): Promise<EstimateTypeView[]> {
        return await lastValueFrom(this.client.estimateTypeGetAll());
    }

    async getAwardableEstimateTypes(): Promise<EstimateTypeView[]> {
        return await lastValueFrom(this.client.estimateTypeGetAwardablesEstimateTypes());
    }
}
